import './App.css';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from '../Routes.js';
import { Footer } from '../components/home/footer/Footer.js';

function AppContent() {
  const location = useLocation();
  const hideFooter = location.pathname.startsWith('/orionhub');
  return (
    <div>
      <AppRoutes />
      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
